import proyecto from '../../api/Proyecto';

export const getUsuarios = async () => {
  const response = await proyecto.get('/usuarios');
  return response.data;
};

export const crearUsuario = async (usuario) => {
  const response = await proyecto.post('/usuarios', usuario);
  return response.data;
};

export const actualizarUsuario = async (id, usuario) => {
  const response = await proyecto.put(`/usuarios/${id}`, usuario);
  return response.data;
};

export const desactivarUsuario = async (id) => {
  const response = await proyecto.delete(`/usuarios/${id}`);
  return response.data;
};

